import React from 'react';
import { Button, Dimmer, Form, Grid, Header, Image, Loader, Segment } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import logo from 'resources/logo.png';
import * as styles from './styles';
import { Link, withRouter } from 'react-router-dom';
import Auth from 'stores/Auth';
import MsgStore from 'stores/MsgStore';
import MessageBox from 'components/MessageBox';
import { observable } from 'mobx';
import { colors } from '../../../styling/variables';

@withRouter
@inject('auth')
@observer
export default class Login extends React.Component {
	props: {
		auth: Auth
	};

	@observable isLoading: boolean = false;
	@observable username: string = '';
	@observable password: string = '';
	@observable step: number = 0;
	@observable isUserAuthenticated: boolean = false;
	@observable token: string = '';

	msgStore = new MsgStore();

	componentDidMount(): void {
		let authError = this.props.auth.errorMessage;
		if (authError) {
			if (authError === 'Unauthorized') {
				authError = 'Due to inactivity you have been logged out.';
			}
			this.msgStore.setError(authError);
		}
		if (window.addEventListener) {
			window.addEventListener('storage', this.sessionStorage_handler, true);
		} else {
			window.attachEvent('onstorage', this.sessionStorage_handler);
		}
	}

	sessionStorage_handler = async event => {
		if (!event) {
			event = window.event;
		}
		if (!event.newValue) return;
		const self = this;
		if (sessionStorage.length && event.key == 'sessionStorage') {
			this.isLoading = true;
			await self.props.auth.rootStore.init();
			const { href } = window.location;
			window.location.href = href.replace('/login', '');
		}
	};

	render() {
		const { auth, history } = this.props;
		const { username, password, token, step } = this;
		return (
			<div className={styles.loginPage}>
				<Grid textAlign="center" style={{ height: '100%' }} verticalAlign="middle">
					{step === 0 ? (
						<Grid.Column style={{ maxWidth: 450 }}>
							<Header as="h2" textAlign="center" color="blue">
								<Image src={logo} className={styles.logo} />
								<div>Log-in to your account</div>
							</Header>
							<Form size="large">
								<Segment>
									<Dimmer active={this.isLoading} inverted>
										<Loader content="Loading" />
									</Dimmer>

									<Form.Input
										fluid
										icon="envelope outline"
										iconPosition="left"
										placeholder="E-mail address"
										autoComplete="username"
										value={username}
										onChange={e => {
											this.username = e.target.value;
										}}
									/>
									<Form.Input
										fluid
										icon="lock"
										iconPosition="left"
										placeholder="Password"
										type="password"
										autoComplete="current-password"
										value={password}
										onChange={e => {
											this.password = e.target.value;
										}}
									/>

									<Button
										fluid
										primary
										size="large"
										onClick={async () => {
											try {
												this.isLoading = true;
												this.msgStore.clear();
												const token = await auth.authenticateUser(username, password);
												if (token) {
													if (token !== 'OTP') {
														history.push('/app');
													} else {
														this.step = 1;
													}
												}
											} catch (err) {
												console.log(err);
												this.msgStore.setError(err);
											} finally {
												this.isLoading = false;
											}
										}}
									>
										Login
									</Button>

									<p className={styles.passwordResetBox}>
										<Link to="/password-reset">Password reset</Link>
									</p>

									<MessageBox msgStore={this.msgStore} />
								</Segment>
							</Form>
						</Grid.Column>
					) : (
						<Grid.Column style={{ maxWidth: 450 }}>
							<Header as="h2" color="blue" textAlign="center">
								<Image src={logo} className={styles.logo} />
								<div>Enter SMS token</div>
							</Header>
							<Form size="large">
								<Segment>
									<Dimmer active={this.isLoading} inverted>
										<Loader content="Loading" />
									</Dimmer>
									<Form.Input
										fluid
										icon="key"
										iconPosition="left"
										placeholder="SMS token"
										value={token}
										onChange={e => {
											this.token = e.target.value;
										}}
									/>
									<Button
										color="blue"
										fluid
										size="large"
										onClick={async () => {
											try {
												this.isLoading = true;
												this.msgStore.clear();
												let res = await auth.authenticateUser(username, password, token);
												if (res && res !== 'OTP') {
													history.push('/app');
												}
											} catch (err) {
												this.msgStore.setError(err);
											} finally {
												this.isLoading = false;
											}
										}}
									>
										Login
									</Button>
								</Segment>
							</Form>
							<MessageBox msgStore={this.msgStore} />
						</Grid.Column>
					)}
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/public/Login/index.js